import { render, staticRenderFns } from "./ChangePromo.vue?vue&type=template&id=8f73cb46&scoped=true&"
import script from "./ChangePromo.vue?vue&type=script&lang=js&"
export * from "./ChangePromo.vue?vue&type=script&lang=js&"
import style0 from "./ChangePromo.vue?vue&type=style&index=0&id=8f73cb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f73cb46",
  null
  
)

export default component.exports